module.exports = __webpack_public_path__ + "img/hsg_logo.d7f2ece3.png";